var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2209",
    transform: "translate(-87 -189)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 38",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(87 189)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.523 25.864a2.433 2.433 0 0 1-1.787-.736A2.433 2.433 0 0 1 2 23.341V6.523a2.433 2.433 0 0 1 .736-1.787A2.433 2.433 0 0 1 4.523 4h31.954A2.512 2.512 0 0 1 39 6.523v16.818a2.512 2.512 0 0 1-2.523 2.523zm0-2.523h31.954V6.523H4.523zm0 0zm13.455-3.784a16.249 16.249 0 0 0 5.739-1.03 13.215 13.215 0 0 0 4.856-3.174 3.273 3.273 0 0 0 1.556 2.418 6.008 6.008 0 0 0 2.985.946v-7.569a6.539 6.539 0 0 0-3.048.988 3.136 3.136 0 0 0-1.535 2.418 15.194 15.194 0 0 0-10.553-4.247 17.029 17.029 0 0 0-6.055 1.093 10.749 10.749 0 0 0-4.793 3.532 10.49 10.49 0 0 0 4.793 3.553 17.326 17.326 0 0 0 6.054 1.072z",
    transform: "translate(97 205.182)",
    style: {
      fill: "#ff731d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFood);
export default __webpack_public_path__ + "static/media/icon-food.7cbfd7ad.svg";
export { ForwardRef as ReactComponent };